import AnalyseTanoEd from "../components/VueClasse/AnalyseTanoEd";
import { useUser } from "../context/UserContext";
import { useClasseContext } from "../context/ClasseContext";
import EmptyClassroom from "../components/VueClasse/EmptyClassroom";
import { useParams } from "react-router-dom";

// Le tableau de bord d'une classe ou d'un groupe : L'analyse de TanoEd, seule
// (décision du prof, 03/10/2026). Le bilan des savoirs, la progression et les
// raccourcis « Évaluer en ligne » / « Évaluations nationales » sont retirés :
// le menu Créer et l'onglet Savoirs y mènent déjà.
function DetailClasse({classeDetail}){
    const {user, matiereFilter} = useUser();
    const {classeNom} = useClasseContext();
    const { idclasse } = useParams();

    // Empty state — même écran pour tous les rôles ; l'import ne se fait plus
    // par classe : EmptyClassroom renvoie vers le wizard établissement quand le
    // rôle l'autorise (chef ou délégué), sinon explique quoi demander.
    if (!classeDetail.eleves || classeDetail.eleves.length === 0) {
        // Conteneur EN FLUX (l'ancien overlay fixed laissait les onglets
        // Pilotage visibles derrière, recouvrait la sidebar sous xl, et son
        // centrage vertical coupait le haut de la carte sur petit écran
        // sans possibilité de scroller). items-start + overflow-y-auto :
        // la carte responsive d'EmptyClassroom scrolle naturellement.
        return (
            <div className="w-full min-h-full flex items-start justify-center overflow-y-auto bg-sky-100 p-2 sm:p-4">
                <EmptyClassroom
                    matiere={matiereFilter}
                    classe={classeNom || "cette classe"}
                    role={user.role === 'chef' ? 'chef' : 'prof'}
                />
            </div>
        );
    }

    return(
    <div className="w-full h-screen overflow-y-auto p-4 lg:p-6 pt-2 lg:pt-2 pb-10">
      <div className="max-w-6xl rounded-2xl shadow-lg shadow-blue-500/5 pilotage-enter">
        <AnalyseTanoEd key={`analyse-${idclasse}`} />
      </div>
    </div>
    )
}
export default DetailClasse;
